import { Box, Skeleton, Stack } from "@mui/material";

const FieldsListSkeleton = () => {
  return (
    <>
      {[1, 2, 3, 4].map((item) => (
        <Box
          border="0.5px solid lightgrey"
          borderRadius="10px"
          p={2}
          width="100%"
          key={item}
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignContent="center"
        >
          <Stack spacing={2} direction="row">
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="text" width={120} />
          </Stack>
          <Skeleton variant="rounded" width={70} height={24} />
        </Box>
      ))}
    </>
  );
};

export default FieldsListSkeleton;
